import { FETCH_CLASSES, FETCH_CLASSES_SUCCESS, FETCH_CLASSES_FAILURE } from '../actions';

const initialState = {
 classes: [],
  loading: true,
  err: null,
  haveData: false
};

export const reducer = (state = initialState, action) => {
  switch(action.type) {
    case FETCH_CLASSES:
      return {
        ...state,
        loading: true,
        err: null,
        haveData: false
      };
    case FETCH_CLASSES_SUCCESS:
      return {
        ...state,
        loading: false,   
        haveData: true,     
        classes: action.data
      };
    case FETCH_CLASSES_FAILURE:
      return {
        ...state,
        loading: false,
        haveData: false,
        err: action.error,
        classes: []
      };
    default:
      return state;
  }
}